import { initAccordions } from '../packs/accordion.js';
import { initFlashHelpers } from '../packs/flash-helpers';
import { initFormHelpers } from '../packs/form-helpers.js';
import { initNavigation } from '../packs/navigation.js';

initNavigation();
initFlashHelpers();
initFormHelpers();
initAccordions();
